module.exports = __webpack_public_path__ + "img/rain_2.015642dd.svg";